import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { t } from 'ttag';
import { useMutation } from '@apollo/react-hooks';
import { makeStyles } from '@material-ui/core/styles';

import { gql } from 'apollo-boost';
import Upload from '../Upload/index';

export const createMutation = gql`
  mutation uploadFile($fileField: UploadFileObjectType!, $objectType: String!) {
    uploadFile(fileField: $fileField, objectType: $objectType) {
      ok
      fileObject {
        id
        name
        originalName
        url
        status
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  large: {
    width: theme.spacing(15),
    height: theme.spacing(15),
  },
}));

const UploadImage = ({ name, onChange, multiple, objectType, fileObject }) => {
  const classes = useStyles();
  const [file, setFileObject] = React.useState(fileObject);
  const [savePhoto] = useMutation(createMutation);

  const handleOnChange = async (file) => {
    const { data } = await savePhoto({
      variables: {
        fileField: file,
        objectType,
      },
    });
    const { uploadFile } = data;
    if (uploadFile.ok) {
      setFileObject(uploadFile.fileObject);
      onChange({ target: { name, value: uploadFile.fileObject } });
    }
  };

  return (
    <div>
      <Upload id='uploadImage' onUpload={handleOnChange} mulitple={multiple}>
        <Button
          variant='outlined'
          color='primary'
          component='span'
          size='large'
        >
          {t`Завантажити`}
          <AccountBoxIcon style={{ marginLeft: '5px' }} />
        </Button>
      </Upload>
      <br />
      {file && file.url && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Avatar variant='square' src={file.url} className={classes.large} />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default UploadImage;
